// i18n/en.js
export default {
    home: {
        title: 'Learn faster and more enjoyably for better grades',
        subtitle: 'With this review program, you learn the theory you need to know quickly and enjoyably. With Ikleeralles.nl, reviewing is no longer boring!',
        login: 'Login',
        register: 'Register',
    }
    // ... Add other English translations
};